import React, { useEffect, useState } from 'react';
import {
  Flex,
  Text,
  InputText,
  SelectTag,
  Button,
  Icon,
} from '@shopuptech/expo-shopup-ui';
import { getLoadableData } from '../mainhome/Utils/helpers';
import { useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import {
  designationApproversTrigger,
  fetchDesignationApprovers,
} from './store/atoms';
import {
  designationApproverInitialState,
  requestAccess,
} from './store/apiHelpers';
import { FormikHelpers, useFormik } from 'formik';
import { commonStyles } from '../../styles';
import { useUserLogin } from '../../hooks/useUserLogin';

type FormValues = {
  designation: string;
  approver: string;
  comments?: string;
};
const RequestAccessScreen = () => {
  const [reqLoading, setReqLoading] = useState(false);
  const [requestedResMessage, setRequestedResMessage] = useState('');
  const setTrigger = useSetRecoilState(designationApproversTrigger);

  useEffect(() => {
    setTrigger((prev) => prev + 1);
  }, [setTrigger]);

  const listingLoadable = useRecoilValueLoadable(fetchDesignationApprovers);
  const { isRequestAccessFlow } = useUserLogin();
  const { isLoading, response: data } = getLoadableData(
    listingLoadable,
    designationApproverInitialState,
  );

  const handleRequestAccess = async (
    values: FormValues,
    { resetForm }: FormikHelpers<FormValues>,
  ) => {
    setReqLoading(true);
    const response = await requestAccess({
      designation: values.designation,
      approverId: Number(values.approver),
      comments: values.comments,
    });
    setReqLoading(false);
    if (response) {
      resetForm();
      setRequestedResMessage(response);
    }
  };
  const formik = useFormik<FormValues>({
    initialValues: {
      designation: '',
      approver: '',
    },
    onSubmit: handleRequestAccess,
  });
  const { values, handleChange, handleSubmit, setFieldValue } = formik;

  const isDisabledSubmit = !values.designation || !values.approver || isLoading;

  if (!isRequestAccessFlow) return null;
  if (requestedResMessage) {
    return (
      <Flex center middle overrideStyle={commonStyles.overAllConatiner}>
        <Flex center overrideStyle={commonStyles.overAll}>
          <Icon name="Loader" size="extralarge" />
          <Text bold size={20} overrideStyle={commonStyles.accessText}>
            Request Sent
          </Text>

          <Text size={16} center>
            {requestedResMessage}
          </Text>
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex center middle overrideStyle={commonStyles.overAllConatiner}>
      <Flex overrideStyle={commonStyles.overAll}>
        <Flex center>
          <Icon name="MailSend" size="extralarge" />
          <Text bold size={20} overrideStyle={commonStyles.accessText}>
            Request Access
          </Text>
        </Flex>

        <SelectTag
          label="Select your designation"
          placeholder="Choose designation"
          testID="designation-select"
          onChange={handleChange('designation')}
          options={data.designations}
          value={values.designation}
          sizeType="medium"
          contain
          search
          maxHeight={220}
          loading={isLoading}
          labelKey="designation"
          valueKey="designation"
        />
        <SelectTag
          label="Select your approver"
          placeholder="Choose approver"
          testID="approver-select"
          onChange={(value: number) => setFieldValue('approver', value)}
          options={data.approvers}
          value={values.approver}
          sizeType="medium"
          contain
          search
          maxHeight={220}
          loading={isLoading}
          labelKey="name"
          valueKey="id"
        />
        <InputText
          label="Comments"
          placeholder="Add comments"
          testID="comments"
          onChange={handleChange('comments')}
          value={values.comments}
          size="medium"
          contain
          multiline
        />
        <Button
          testID="request-access-button"
          buttonSize="medium"
          onClick={handleSubmit}
          disabled={isDisabledSubmit}
          loading={reqLoading}
          contain>
          Request
        </Button>
      </Flex>
    </Flex>
  );
};

export default RequestAccessScreen;
